<!--
 * @Descripttion:
 * @Author: cuiyingchun
 * @Date: 2021-04-08 08:44:13
 * @LastEditors: liang
 * @LastEditTime: 2021-09-26 11:20:31
 * @Introduce: 举报管理
-->
<template>
<div class="box">
  <h1 class="perText1">平台反馈
    <span @click="toHistory">查看历史记录</span>
  </h1>
    <div class="bg">
      <div style="padding:20px 0 5px 0;font-weight:bold;display:flex">
        <div style="font-size:15px;width:90px">反馈类型：</div>
        <el-radio-group v-model="feedbackType">
          <el-radio style="padding-bottom:15px;" v-for="item in feedbackTypeOptions" :key="item.dictCode" :label="item.dictCode">{{item.dictName}}</el-radio>
        </el-radio-group>
      </div>
      <el-input v-model.trim="questionContent" rows="10" type="textarea" placeholder="请输入您要反馈的问题..."></el-input>
      <div style="text-align:center;padding-top:20px">
        <el-button type="primary" @click="submit" :loading='btnload'>提 交</el-button>
      </div>
    </div>
    <el-dialog  title="查看历史记录" :visible.sync="feedbacklistshow"  width="70%">
      <feedbacklist ref="feedbacklist" :feedbackTypeOptions='feedbackTypeOptions' v-if="feedbacklistshow"></feedbacklist>
      <span slot="footer" class="dialog-footer">
        <el-button @click="feedbacklistshow = false">关闭</el-button>
      </span>
    </el-dialog>
</div>
</template>
<script>
import feedbacklist from './feedbacklist'
export default {
  data () {
    return {
      btnload: false,
      questionContent: '',
      feedbacklistshow: false,
      feedbackType: '',
      feedbackTypeOptions: []
    }
  },
  created () { this.getFeedbackType() },
  components: { feedbacklist },
  methods: {
    submit () {
      if (!this.questionContent) {
        this.$message.warning('请您输入内容')
      } else {
        this.btnload = true
        this.$post('/training/customerService/save', {
          feedbackType: this.feedbackType,
          questionContent: this.questionContent,
          serviceType: '2'
        }).then((res) => {
          this.btnload = false
          if (res.code === 0) {
            this.$message.success('提交成功')
            this.questionContent = ''
          }
        })
      }
    },
    getFeedbackType () {
      this.$get('/sys/dict/type/feedbackType')
        .then((res) => {
          this.feedbackTypeOptions = res.data.list
          this.feedbackType = res.data.list[0].dictCode
        })
        .catch(() => {})
    },
    toHistory () {
      this.feedbacklistshow = true
      this.$nextTick(() => {
        this.$refs['feedbacklist'].init()
      })
    }
  }
}
</script>
<style scoped lang='scss'>
.perText1{
    font-size: 22px;width: 100%;overflow: hidden;
    span{display: block;float: right;font-weight: normal;font-size: 16px;cursor: pointer;color: #409EFF;
    &:hover{text-decoration: underline;}
    }
  }
.box {
  min-height: calc(100vh - 430px);
  overflow: hidden;
  padding-left:20px;
  .bg {
    width: 100%;
    margin: 0 auto;
    margin-top: 20px;
  }
}
</style>
